import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
providedIn: 'root'
})

export class LoadingService {

loading$: Subject<boolean> = new Subject();
timeout: any = null;

constructor() { }

  startLoading() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        
        this.timeout = setTimeout(() => {
        
            this.loading$.next(true);
            this.timeout = null;
        }, 350);
    }

    stopLoading() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.loading$.next(false);
    }
}
